<script setup>
import { defineProps, computed, ref} from "vue";
import LinhaDeVinculos from "./LinhaDeVinculos.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "recebimento",
]);

//==================================================================//
//======================== Vinculos Headers ========================//
//==================================================================//

let vinculosHeaders = [
    { text: 'N° da Conta a Receber',  value: 'contaAReceber'},
    { text: 'Valor Vinculado',  value: 'valorRecebimento'},
    { text: '',                 value: 'espaco'},
]

//==================================================================//
//========================= Mostra Vinculos ========================//
//==================================================================//

let mostraVinculos = computed(()=>{

    if(props?.recebimento?.vinculos?.length <= 0){
        return false;
    }

    if(props?.recebimento?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row-table"
        v-show="mostraVinculos"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <div class="c-table-wrapper">

                    <div class="c-table">

                        <div class="c-table__headers">

                            <div class="c-table__header" v-for="vinculoHeader in vinculosHeaders"
                                :key="vinculoHeader.value"
                            >

                                <div class="c-table__header-content">

                                    {{vinculoHeader.text}}

                                </div>
                                
                            </div>

                        </div>
                        <div class="c-table__body">

                            <LinhaDeVinculos v-for="vinculo in props?.recebimento?.vinculos"
                                :key="vinculo.id"
                                :dado="props?.dado"
                                :recebimento="props?.recebimento"
                                :vinculo="vinculo"
                            ></LinhaDeVinculos>

                        </div>

                    </div>

                </div>
                
            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row-table{
    display: contents;
}

.c-table__row-table:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: grid;
    grid-column: 1 / -1;
    font-size: 0.875rem;
}

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px 12px 12px 12px !important;
}

.c-table{
    background: #ffffff;
    display: grid;
    grid-template-columns: max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__headers{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-table__header{
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #dedede;
    color: #363636;
}

.c-table__body{
    display: contents;
}

</style>
